import React, { useState, useRef } from 'react';
import { ICompareProduct } from 'base/interfaces/product-compare';
import { Button } from 'antd';
import { trackAddToCart } from 'base/utils/tracker';
import { postAddCart } from '@base/product/services';
import Message from '@base/lib/Message';
import { useStore } from 'base/store';
import { useTrans } from 'base/utils/i18n';

declare type IProps = {
    product: ICompareProduct,
    'data-t-tar'?: string;
    'data-t-pos'?: string;
}

const getThumbSrc = (variantId: string): string => {
    const imgWrap = document.querySelector(`.js-compare-${variantId}`);
    if (imgWrap) {
        const img = imgWrap.querySelector('img');
        if (img) {
            return img.currentSrc;
        }
    }
    return ''
};

const CompareAddToCart = React.forwardRef<HTMLDivElement, IProps>((props, ref) => {
    const {
        product,
        'data-t-tar': dataTrackTarget,
        'data-t-pos': dataTrackPosition,
    } = props;
    const [submitting, setSubmitting] = useState<boolean>(false);
    const { miniCartStore } = useStore();
    const { t } = useTrans();

    const handleAddToCart = () => {
        trackAddToCart([{ ...product, num: 1 }]);
        setSubmitting(true);
        return postAddCart([{
            productVariantId: product.variantId,
            num: 1,
        }]).then(res => {
            if (!res.addFailProductName || res.addFailProductName.length === 0) {
                let src = getThumbSrc(product.variantId);
                miniCartStore.afterAddCart(1, src ? [src] : void 0);
            } else {
                Message.error(t('web_product_compare_item_unavailable', { name: res.addFailProductName[0] }));
            }
        }).finally(() => {
            setSubmitting(false);
        });
    };

    return (
        <div data-t-tar={dataTrackTarget} data-t-pos={dataTrackPosition}>
            {product.isStock ? (
                <Button
                    ref={ref}
                    type="primary"
                    loading={submitting}
                    onClick={handleAddToCart}
                >
                    {t('web_product_add_to_cart')}
                </Button>
            ) : (
                <Button ref={ref} type="primary" disabled>
                    {t('web_product_sold_out')}
                </Button>
            )}
        </div>
    );
});

export default CompareAddToCart;
